var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.6,
    height: 31.6,
    x: 0.7,
    y: 0.7,
    fill: "#fff",
    rx: 4.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#298FC2",
    fillRule: "evenodd",
    d: "M31.319 11.327c-.02.13-.042.262-.067.399-.865 4.599-3.825 6.187-7.605 6.187h-1.924a.945.945 0 0 0-.924.82l-1.265 8.305c-.047.31.184.59.486.59h3.414a.83.83 0 0 0 .811-.717l.034-.18.642-4.223.042-.232a.83.83 0 0 1 .81-.718h.511c3.308 0 5.897-1.39 6.654-5.414.316-1.68.152-3.084-.685-4.07a3.278 3.278 0 0 0-.934-.747Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22284F",
    fillRule: "evenodd",
    d: "M30.414 10.954a6.613 6.613 0 0 0-.842-.194 10.343 10.343 0 0 0-1.696-.128h-5.142a.794.794 0 0 0-.355.083.846.846 0 0 0-.456.636l-1.093 7.173-.032.21a.945.945 0 0 1 .924-.82h1.925c3.78 0 6.74-1.59 7.605-6.189.025-.136.047-.268.067-.398a4.519 4.519 0 0 0-.905-.373Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#28356A",
    fillRule: "evenodd",
    d: "M21.923 11.35a.844.844 0 0 1 .457-.634.792.792 0 0 1 .354-.083h5.142c.609 0 1.178.041 1.697.128a6.521 6.521 0 0 1 1.036.256c.254.087.492.19.71.31.258-1.7-.002-2.856-.889-3.904-.979-1.154-2.744-1.648-5.004-1.648h-6.56a.948.948 0 0 0-.927.82L15.207 24.53c-.054.355.21.675.556.675h4.05l2.11-13.854Z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46.6,
    height: 31.6,
    x: 0.7,
    y: 0.7,
    stroke: "#D6DCE9",
    strokeWidth: 1.4,
    rx: 4.3
  })));
};
export default SvgPaypal;